import { trackEvent } from '@repo/common/analytics';
import { Breadcrumbs } from '@repo/foundations';
import { useCallback } from 'react';
import { useAuthUser } from '../../../api';
import {
	NavBarBreadcrumbWrapper,
	NavBarWrapper,
} from '../../../components/SecodaAppShell/SecodaNavBar';

export function AiImpactDashboardPageNavBar() {
	const { user, workspace } = useAuthUser();

	const handleBreadcrumbClick = useCallback(() => {
		trackEvent(
			'ai_impact_dashboard/breadcrumb_clicked',
			{
				breadcrumb_target: 'analytics',
			},
			user,
			workspace
		);
	}, [user, workspace]);

	return (
		<NavBarWrapper>
			<NavBarBreadcrumbWrapper>
				<Breadcrumbs
					crumbs={[
						{ title: 'Analytics', href: '/analytics' },
						{
							title: 'AI Analytics',
							href: '/analytics/ai-analytics',
						},
					]}
					onBreadcrumbClick={handleBreadcrumbClick}
				/>
			</NavBarBreadcrumbWrapper>
		</NavBarWrapper>
	);
}

export default AiImpactDashboardPageNavBar;
